module.exports = "/_next/static/images/3b3f6f3a8b759b10f2c3d39fd7606892-card-lock-icon.svg";